import React, { useState, useEffect } from 'react';
import { Form, Button } from '@blueprintnyc/bpnyc-common';
import { Toggle } from '@blueprintnyc/bpnyc-common-admin';
import OmniPicker from '@/components/OmniPicker';
import ButtonItemOptions from './ButtonItemOptions';
import EventGroupsPicker from '@/components/EventGroupsPicker';

const ButtonWidgetOptions = props => {
	const {
		event,
		widgetToUpdate,
		handleChange,
		widgetProps,
		onUpdate,
		setOmniPicker,
		omniPicker,
		handlePickMedia,
		setWidgetToUpdate,
		handleGroupChange,
		targetKeys,
	} = props;
	const { amount = '1' } = widgetProps;
	const [buttonProps, setButtonProps] = useState([]);
	const buttonArr = new Array(Number(amount)).fill('');

	useEffect(() => {
		// backwards compatibility TO BE DELETED
		if (!widgetProps.buttons) {
			const { text, buttonColor, textColor, onPress, position, source } = widgetProps;
			widgetProps.amount = '1';
			setButtonProps([{ text, buttonColor, textColor, onPress, position, source }]);
		} else setButtonProps(widgetProps.buttons);
	}, [widgetProps]);

	useEffect(() => {
		if (widgetProps.buttons && amount !== widgetToUpdate.props.amount) {
			const updatedButtonArr = widgetProps.buttons.slice(0, Number(amount));
			setWidgetToUpdate({
				...widgetToUpdate,
				props: { ...widgetProps, buttons: updatedButtonArr },
				toUpdate: true,
			});
			setButtonProps(updatedButtonArr);
		}
	}, [amount]);

	const handleSetButtonProps = (key, index, value) => {
		let arr = [...buttonProps];
		if (arr[index]) arr[index][key] = value;
		else arr = [...buttonProps, { ...buttonProps[index], [key]: value }];
		if (arr[index] && !arr[index].position) arr[index].position = 'left';
		setButtonProps(arr);
		handleChange({ ...widgetProps, buttons: arr });
	};

	const handlePickOmniItem = (pickedLink, index) => {
		handleSetButtonProps('onPress', index, pickedLink);
		setOmniPicker({ open: false, mediaPicker: false, from: '', index: null });
	};

	return (
		<Form initialValues={widgetToUpdate.props} onChange={handleChange}>
			<div className="WidgetUpdateForm">
				<Form.Item label="Number of Buttons in Row" name="amount">
					<Toggle toggleOptions={['1', '2']} />
				</Form.Item>
				{buttonArr &&
					buttonArr.map((_, index) => (
						<ButtonItemOptions
							{...props}
							buttonProps={buttonProps}
							index={index}
							handleSetButtonProps={handleSetButtonProps}
							handlePickOmniItem={handlePickOmniItem}
							key={'button-item-option-' + index}
						/>
					))}
				<h4 className="admin-form-item-label">Group Permissions</h4>
				<div className="groups-picker">
					<EventGroupsPicker
						event={event}
						handleChange={handleGroupChange}
						targetKeys={targetKeys}
					/>
				</div>
			</div>
			<Button type="submit" style={{ marginTop: '15px' }} onClick={() => onUpdate(widgetProps)}>
				Submit
			</Button>
			<OmniPicker
				event={event}
				visible={omniPicker.open}
				onCancel={() => {
					console.log('onCancel');
					setOmniPicker({ open: false, mediaPicker: false, from: '', onPress: {} });
				}}
				handlePickItem={pickedLink => handlePickOmniItem(pickedLink, omniPicker.index)}
				handlePickMedia={handlePickMedia}
				mediaPicker={omniPicker.mediaPicker}
				from={omniPicker.from}
				onPress={omniPicker.onPress}
			/>
		</Form>
	);
};

export default ButtonWidgetOptions;
